export const ADD_CART_ITEM = "add-cart-item";
export const GET_FOOD = "get-food";
